/* eslint-disable */
import { TranslateService } from '@ngx-translate/core';

export function isUndefined(value: any) {
  return typeof value === 'undefined';
}

export function isObject(value: any) {
  return value !== null && typeof value === 'object';
}

export function extractDeepPropertyByMapKey(obj: any, map: string): any {
  const keys = map.split('.');
  const head = keys.shift();

  return keys.reduce((prop: any, key: string) => (!isUndefined(prop) && !isUndefined(prop[key]) ? prop[key] : undefined), obj[head || '']);
}

export const daysDE = ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'];
export const daysEN = ['SO', 'MO', 'Tu', 'WE', 'TH', 'FR', 'SA'];

export function formatValueForCurrency(value: number) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function getCustomSortNumbersStrings<T>(value1: T | undefined, value2: T | undefined): 1 | -1 | 0 {
  if (value1 === null && value2 !== null) {
    return -1;
  } else if (value2 === null && value1 !== null) {
    return 1;
  } else if (value1 === null && value2 === null) {
    return 0;
  }

  if (value1 > value2) {
    return 1;
  } else if (value1 < value2) {
    return -1;
  }
  return 0;
}

export function getCustomSortBoolean(value1: boolean, value2: boolean): 1 | -1 | 0 {
  if (value1 === value2) {
    return 0;
  } else if (value1 === false && value2 === true) {
    return -1;
  } else {
    return 1;
  }
}

export function getCustomSortDate(value1: Date, value2: Date): 1 | -1 | 0 {
  const timestampValue1 = value1.getTime();
  const timestampValue2 = value2.getTime();
  return getCustomSortNumbersStrings<number>(timestampValue1, timestampValue2);
}

export function customSortWithEmptyValuesOnTop<T>(value1: T, value2: T, translateService: TranslateService): number {
  const emptyStatusTranslated = translateService.instant('accounting.statusEmpty');

  if (value1 === emptyStatusTranslated && value2 !== emptyStatusTranslated) {
    return -1;
  } else if (value2 === emptyStatusTranslated && value1 !== emptyStatusTranslated) {
    return 1;
  } else if (value1 === emptyStatusTranslated && value2 === emptyStatusTranslated) {
    return 0;
  }

  return getCustomSortNumbersStrings<T>(value1, value2);
}

import { ITranslatableOption } from '../interfaces/changelog/IChangelogConfig';

/**
 * Generic function to create a value transformer for enum fields in changelog
 * @param options Array of translatable options with title and translationKey
 * @returns A transformer function that translates enum values to localized strings
 * @example
 * const accountTypeTransformer = createEnumValueTransformer(AccountsOperations.accountTypes);
 * // Use in IChangelogFieldConfig:
 * { value: 'Type', label: 'account.accountType', valueTransformer: accountTypeTransformer }
 */
export function createEnumValueTransformer<T>(
  options: readonly ITranslatableOption<T>[],
): (title: T | null, translateService: TranslateService) => string {
  return (title: T | null, translateService: TranslateService): string => {
    if (title === null || title === undefined) {
      return '-';
    }
    const option = options.find(opt => opt.title === title);
    return option ? (translateService.instant(option.translationKey) as string) : String(title);
  };
}
